const URLConstants = {
    Authenticate: '/v1/User/Authenticate',
    ChangeUserPassword: '/v1/User/UpdateUserPassword',
    ChangePassword: '/v1/User/UpdatePassword',
    GetAllUser: '/v1/User/GetAllUsers',
    DeleteUser: '/v1/User/DeleteUser',
    AddUser: '/v1/User/AddUser',
    UpdateUser: '/v1/User/UpdateUser',
    GetUserById: '/v1/User/GetUserById',
    GetAllSensor: '/v1/AQData/GetAllSensorLocationData',
    DeleteSensor: '/v1/AQData/DeleteSensorLocation',
    AddSensor: '/v1/AQData/AddSensorLocation',
    UpdateSensor: '/v1/AQData/EditSensorLocation',
    AddUserSettings: '/v1/User/UpdateUserSettings',
    GetUserSettings: '/v1/User/GetUserSettings',
    GetSensorById: '/v1/AQData/GetSensorLocationDataByID',
    GetAllSensorData: '/v1/AQData/GetAllDecodedDataByDate',
    GetSensorDataById: '/v1/AQData/GetDecodedDataByID',
    DownloadDecodedDataByID: '/v1/AQData/DownloadDecodedDataByID',
    DownloadDecodedDataByDate: '/v1/AQData/DownloadDecodedDataByDate',
    GetChartDataForSensor: '/v1/AQData/GetChartDataForSensor',
    GetUniqueBuildingNames: '/v1/AQData/GetUniqueBuildingNames',
    SetDeviceDesiredValue:'/v1/AQData/SetDeviceDesiredValue',
    GetDeviceState:'/v1/AQData/GetDeviceState',
    GetAllFile: '/v1/AQData/GetDownloadFileStatus',
    DeleteCSVFile: '/v1/AQData/DeleteCSVFile',
    DownloadCSVFile: '/v1/AQData/DownloadCSVFile',
    AddIAQSensor: '/v1/AQData/AddIAQSensorLocation',
    GetIAQIndexDecodedDataByID: '/v1/IAQ/GetIAQIndexDecodedDataByID',
    GetIAQIndexChartDataForSensor: '/v1/IAQ/GetIAQIndexChartDataForSensor',
    GetIAQRealtimeViewDataByICCID: "/v1/IAQ/GetIAQIndexByICCIDId",
    GetIAQRealtimeViewChartDataByICCID: "v1/IAQ/GetIAQChartData",
    DownloadDecodedIAQDataByID: '/v1/IAQ/DownloadDecodedIAQDataByID',
    DeleteIAQSensorLocation: '/v1/IAQ/DeleteIAQSensorLocation',
    GetAirIndexIAQDevices: '/v1/IAQ/GetAirIndexIAQDevices',
    GetLegendDetails: '/v1/IAQ/GetLegendDetails',
    DeleteSelectedCSVFiles:'/v1/AQData/DeleteSelectedCSVFiles',
    GetIAQThresholdByICCID: "/v1/IAQ/GetThresholdByICCID",
    GetAllSensorDevicesWithoutPagination:"/v1/AQData/GetAllIAQSensorLocationWithoutPagination",
    GetUserDevicesById: "/v1/User/GetDeviceUserDetailsByUserId/DeviceUserDetails",
    AddDeviceUserDetailsByUserId:"/v1/User/AddDeviceUserDetailsByUserId/DeviceUserDetails",
    GetFilterIAQSensors:"/v1/IAQ/GetDashboardSensorDetailsFilter"
 
}

export default URLConstants;